import { Visibility, VisibilityOff } from '@material-ui/icons'
import CloseIcon from '@material-ui/icons/Close'
import { LoadingButton } from '@mui/lab'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { redirect, setCookies } from 'components/Providers/redirectHandlers'
import { cnpj, cpf } from 'cpf-cnpj-validator'
import { Mask } from 'helpers/Masks'
import ValidateSchema from 'helpers/ValidateSchema'
import jwtDecode from 'jwt-decode'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { Field, Form } from 'react-final-form'
import AuthenticationService from 'services/Authentication'
import { useTheme } from 'styled-components'
import * as Yup from 'yup'
import { ButtonSubmit, Content, InputFormText } from './styles'

const loginSchema = Yup.object({
  login: Yup.string()
    .test('test', 'Insira um CPF ou CNPJ válido', (value) => {
      return value ? cpf.isValid(value) || cnpj.isValid(value) : false
    })
    .required('Insira um CPF ou CNPJ'),
  password: Yup.string().required('Por favor insira uma senha'),
})

function VeroLoginForm() {
  const [showPassword, setShowPassword] = useState(false)
  const [valueInputLogin, setValueInputLogin] = useState<string>('')
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const theme = useTheme()

  const handleSubmitValues = async (values: any) => {
    const { login, password } = values

    try {
      const response = await AuthenticationService.authenticationController.login({ login: login.replace(/[^0-9]/g, ''), password, provider: 'vero' })
      const { payload }: { payload: any } = jwtDecode(response.data.data.access)
      setCookies(payload.identity, 'verofamilia')
      redirect('verofamilia')
    } catch (error: any) {
      let message = 'Login e/ou senha inválidos.'
      if (Number(error.response.status) >= 500) message = 'Servidor temporariamente indisponível.'
      if (error.code === 'ECONNABORTED') message = 'Conexão de internet perdida.'
      if (error.response.status !== 401) message = 'Erro desconhecido, entre em contato com seu provedor.'
      enqueueSnackbar(message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        autoHideDuration: 5000,
        action: (
          <IconButton onClick={() => closeSnackbar()} size='large'>
            <CloseIcon />
          </IconButton>
        ),
      })
    }
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <Form
      onSubmit={handleSubmitValues}
      validate={ValidateSchema(loginSchema)}
      render={({ handleSubmit, submitting }) => {
        return (
          <form onSubmit={handleSubmit} autoComplete='off'>
            <Content>
              <InputFormText>
                <Field name='login'>
                  {({ input, meta }) => (
                    <TextField
                      error={meta.error && meta.touched}
                      id='login'
                      label='CPF/CNPJ'
                      type='text'
                      value={valueInputLogin}
                      onChange={(e) => {
                        input.onChange(e)
                        setValueInputLogin(Mask.CPForCNPJ(e.target.value))
                      }}
                      InputProps={{
                        style: { marginTop: '5px' },
                        sx: {
                          '& fieldset': {
                            '& legend': {
                              display: 'none',
                            },
                          },
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          position: 'relative',
                          display: 'contents',
                        },
                        shrink: true,
                      }}
                      helperText={meta.error}
                      size='small'
                      margin='dense'
                      placeholder='Digite seu CPF ou CNPJ'
                    />
                  )}
                </Field>
              </InputFormText>
              <InputFormText>
                <Field name='password'>
                  {({ input, meta }) => (
                    <TextField
                      error={meta.error && meta.touched}
                      id='password'
                      label='Senha'
                      type={showPassword ? 'text' : 'password'}
                      onChange={input.onChange}
                      InputLabelProps={{
                        style: { position: 'relative', display: 'contents' },
                        shrink: true,
                      }}
                      helperText={meta.error}
                      size='small'
                      margin='dense'
                      placeholder='Digite sua senha'
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton aria-label='toggle password visibility' onClick={handleClickShowPassword} edge='end'>
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                        sx: {
                          '& fieldset': {
                            '& legend': {
                              display: 'none',
                            },
                          },
                        },
                        style: { marginTop: '5px' },
                      }}
                    />
                  )}
                </Field>
              </InputFormText>
              <ButtonSubmit>
                <LoadingButton
                  loading={submitting}
                  type='submit'
                  variant='contained'
                  sx={{
                    color: theme.colors.primary.main,
                    backgroundColor: theme.colors.secondary.main,
                    textTransform: 'none',
                    ':hover': { opacity: 0.85, backgroundColor: theme.colors.secondary.main },
                  }}
                >
                  Entrar
                </LoadingButton>
              </ButtonSubmit>
            </Content>
          </form>
        )
      }}
    />
  )
}

export default VeroLoginForm
